module.exports = __webpack_public_path__ + "static/img/samajuri (25).7201466.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (25).jpg
// module id = /D1B
// module chunks = 0